function initializeEventListeners() {
  document.querySelectorAll('.product-card, .section__model-type__block').forEach(element => {
    const button = element.querySelector('.cta-customTileModal');

    if (!button) {
      return;
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();

      const productUrl = element.getAttribute('data-url');

      fetch(productUrl)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');

          const externalConfigurator = doc.querySelector('.web-configurator-container');

          if (externalConfigurator) {
            document.querySelector('.web-configurator-container-tile').innerHTML = externalConfigurator.innerHTML;
          }

          const modalId = button.dataset.modalTarget;
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
          }
        })
        .catch(error => console.error('Error fetching product data:', error));
    });
  });

  const pdpConfigurator = document.querySelector('.web-configurator-container')
  let pdpConfiguratorHTML = ''

  document.querySelectorAll('.cta-line-minicart').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const rootAttribute = document.querySelector('[data-root]').getAttribute('data-root');

      let fetchUrl = '/pages/external-configurator-cart';
      if (rootAttribute && rootAttribute !== '/') {
        fetchUrl = `${rootAttribute}${fetchUrl}`;
      }
      
      fetch(fetchUrl)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');

          const dataKey = button.dataset.key;
          const cartItem = doc.querySelector(`.cart-item[data-key="${dataKey}"] .web-configurator-container`);

          if (cartItem) {
            const modalId = button.dataset.modalTarget;
            const modal = document.getElementById(modalId);

            if (modal) {
              const modalContent = modal.querySelector('.web-configurator-container-tile');
              if (modalContent) {
                modalContent.innerHTML = cartItem.innerHTML;

              }
              modal.style.display = 'flex';
              document.body.style.overflow = 'hidden';
              document.documentElement.style.overflow = 'hidden';

              if (pdpConfigurator) {
                pdpConfiguratorHTML = pdpConfigurator.innerHTML
                pdpConfigurator.innerHTML = ''
              }
              closeMiniCart();
            }
          }
        })
        .catch(error => console.error('Error fetching cart data:', error));
    });
  });

  document.querySelectorAll('.custom-modal-close').forEach(closeButton => {
    closeButton.addEventListener('click', function () {
      const modal = closeButton.closest('.custom-modal');
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = '';

        const contentContainer = modal.querySelector('.web-configurator-container-tile');
        if (contentContainer) {
          contentContainer.innerHTML = '';
        }

        if (pdpConfigurator && pdpConfiguratorHTML) {
          pdpConfigurator.innerHTML = pdpConfiguratorHTML
        }
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initializeEventListeners();
});

document.addEventListener('DOMUpdated', function () {
  initializeEventListeners();
});